'use client';

import { forwardRef } from 'react';
import { Button, type ButtonProps } from '../../components/button';

export type ListPageOptionsMenuItemProps = ButtonProps;

export const ListPageOptionsMenuItem = forwardRef<
  HTMLButtonElement,
  ListPageOptionsMenuItemProps
>((props, ref) => (
  <Button
    ref={ref}
    size="xs"
    variant="ghost"
    w="full"
    h="auto"
    minH="0"
    p="2"
    gap="2"
    justifyContent="flex-start"
    borderRadius="l1"
    fontWeight="normal"
    color="fg.neutral.default"
    {...props}
  />
));

ListPageOptionsMenuItem.displayName = 'ListPageOptionsMenuItem';
